import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LegalNotice = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 py-20">
      <div className="container mx-auto px-4 max-w-4xl">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-sky-600 hover:text-sky-700 mb-8 transition-colors"
        >
          <ArrowLeft size={20} />
          Retour à l'accueil
        </button>

        <h1 className="text-4xl font-bold text-slate-900 mb-8">Mentions Légales</h1>

        <div className="bg-white rounded-xl p-8 shadow-sm space-y-6">
          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Informations sur l'entreprise</h2>
            <div className="space-y-2 text-slate-700">
              <p><strong>Raison sociale :</strong> Garage 1225 Sàrl</p>
              <p><strong>Adresse :</strong> Rue François-Jacquier 17, 1225 Chêne-Bourg, Suisse</p>
              <p><strong>Téléphone :</strong> 022 860 07 07</p>
              <p><strong>Email :</strong> garage1225@bluewin.ch</p>
              <p><strong>IDE :</strong> CHE-305.167.790</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Hébergement</h2>
            <p className="text-slate-700">
              Ce site est hébergé par <strong>Emergent</strong>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Propriété intellectuelle</h2>
            <p className="text-slate-700">
              L'ensemble du contenu de ce site (textes, images, logos) est la propriété de Garage 1225 Sàrl. 
              Toute reproduction, totale ou partielle, est interdite sans autorisation préalable.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Responsabilité</h2>
            <p className="text-slate-700">
              Garage 1225 Sàrl s'efforce de fournir des informations aussi précises que possible sur ce site. 
              Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences 
              dans la mise à jour des informations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Liens externes</h2>
            <p className="text-slate-700">
              Ce site peut contenir des liens vers d'autres sites. Garage 1225 Sàrl n'exerce aucun contrôle 
              sur ces sites et décline toute responsabilité quant à leur contenu.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
